import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar/Sidebar.tsx";
import type { QuotaWithRelations } from "~/modules/quota/api/quota/quotaTypes.ts";
import {
	UpdateQuotaDetailsForm,
} from "~/modules/quota/components/QuotaDetailsView/components/UpdateQuotaDetailsSidebar/UpdateQuotaDetailsForm.tsx";
import {
	getQuotaConsumerProjectIds,
	invalidateProjectQuotaQueries,
	invalidateQuotaQueries,
} from "~/modules/quota/utils/quotaCacheUtils.ts";

type Props = {
	isOpen: boolean;
	onClose: () => void;
	quota: QuotaWithRelations;
};

export const UpdateQuotaDetailsSidebar = ({ isOpen, onClose, quota }: Props) => {
	const queryClient = useQueryClient();

	const handleSuccess = useCallback(async () => {
		await invalidateQuotaQueries(queryClient);
		// The title is part of the QuotaReference on the orders and phases of the consumer projects.
		invalidateProjectQuotaQueries(queryClient, getQuotaConsumerProjectIds(quota.consumers));
		onClose();
	}, [onClose, queryClient, quota.consumers]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			{isOpen && <UpdateQuotaDetailsForm onCancel={onClose}
											   onSuccess={handleSuccess}
											   quota={quota} />}
		</Sidebar>
	);
};
